import {useState, useEffect} from 'react';
import Select from 'react-select';
import {CarbonProjectStandards} from '../../../entities';
import {EditedProject} from '../EditedProject';
import {getProjectStandardName, useCarbonLookups} from '../../../providers/CarbonLookupsProvider';

export function ProjectStandard({
    project,
    setProjectAndValidate
}: {
    project: EditedProject;
    setProjectAndValidate: (project: EditedProject) => void;
}) {
    const {ProjectStandards} = useCarbonLookups();
    const [options, setOptions] = useState<CarbonProjectStandardOption[]>(null);
    const [selectedOption, setSelectedOption] = useState<CarbonProjectStandardOption>(null);

    useEffect(() => {
        setOptions(ProjectStandards.map((x) => ({value: x.Id, label: x.Name})));
    }, [ProjectStandards]);

    useEffect(() => {
        const selected = project.CarbonProjectStandard.current;

        if (!options || !selected) return;

        setSelectedOption(options.find((x) => x.value === selected));
    }, [options]);

    const onChange = (e) => {
        setSelectedOption(e);
        setProjectAndValidate({
            ...project,
            CarbonProjectStandard: project.CarbonProjectStandard.update(e.value)
        });
    };

    return <Select value={selectedOption} onChange={(e) => onChange(e)} options={options} />;
}

export function formatCarbonProjectStandards(standard: CarbonProjectStandards) {
    return getProjectStandardName(standard);
}

type CarbonProjectStandardOption = {
    value: number;
    label: string;
};

export default ProjectStandard;
